export default __webpack_public_path__ + "static/media/taxSlabs_ic.e79564a0.svg";